import React from 'react';
import GenericErrorUI from '../../../components/common/GenericErrorUI';
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI';
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI';
import IconButtonUI from '../../../widgets/action/IconButtonUI';
import SalesTargetCreateModalSF from '../../../components/superUser/account/SalesTargetCreateModalSF';
import EmptyListUI from '../../../widgets/output/EmptyListUI';
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI';
import CardUI from '../../../widgets/layout/CardUI';
import SelectUI from '../../../widgets/input/SelectUI';
import SalesTargetNavUI from './SalesTargetNavUI';
import SalesTargetUpdateModalSF from '../../../components/superUser/account/SalesTargetUpdateModalSF';

const SalesContactPageUI = ({ context, errorList,onRefreshClick,
     salesContactList
   }) =>
(
  <SuperUserHomePageUI
    context={context} className='pg_su_ld' topnav='accounts' dimension=''
    centered={!salesContactList && !errorList} page='salesContacts'
  >
    {
      (!salesContactList && !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {salesContactList &&
      <LRTableActionsUI
        location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <span className='g_m_left_100 g_large'><b>Contacts</b></span>
          </span>
        }
        right={
          <span className='g_flex_h'>
            
          </span>
        }
      />
    }
    {salesContactList && <SalesTargetNavUI page='contacts'/>}
    {
      salesContactList && salesContactList.length === 0 && (
        <EmptyListUI context={context} createEnabled={false} createDisabledMessageLabel='No Sales Contacts' />
      )
    }
    {
      salesContactList && salesContactList.length > 0 && (
        <div>
          <CardUI className='g_m_top_100 g_normal'>
            <table>
              <thead>
                <tr>
                   <td>S.No.</td>
                  <th >Creator</th>
                  <th >Name</th>
                  <th>Title</th>
                  <th>Phone</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {salesContactList.map((salesContact, index) => (
                  <tr key={index}>
                    <td>{index + 1}.</td>
                    <td className='g_text_center'>{salesContact.creatorName}</td>
                    <td className='g_text_center'>{salesContact.name}</td>
                    <td className='g_text_center'>{salesContact.title}</td>
                    <td className='g_text_center'>{salesContact.phone}</td>
                    <td className='g_text_center'>{salesContact.email}</td>
                  </tr>
                ))}
              </tbody>

            </table>
          </CardUI>
        </div>
      )
    }

  </SuperUserHomePageUI>
);

export default SalesContactPageUI;
